<template>
  <div>
    <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col-12 col-md-12 col-lg-8">
          <h1 class="text-white pt-3 px-3">Sales Record</h1>
          <p class="text-white pb-3 px-3">Sales Record Description</p>
        </div>
        <div class="col-12 col-md-12 col-lg-5 align-self-center px-3 text-right">
<!--          <h1 class="display-3 text-white" v-if="isAdmin()">-->
<!--            <small>วันหมดอายุ :</small>-->
<!--            {{dateExp}}-->
<!--          </h1>-->
<!--          <h1 class="display-3 text-white">-->
<!--            <small>ยอดรวมสุทธิทั้งหมด :</small>-->
<!--            {{totalNetPrice | numFormat('0,0.00')}}-->
<!--            <small>บาท</small>-->
<!--          </h1>-->
        </div>
      </div>
    </base-header>
    <div class="text-center" v-if="busy">
      <BlockUI>
        <div class="loader"></div>
      </BlockUI>
    </div>
    <div class="container-fluid mt--8 mb-5">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row justify-content-between">
                <div class="col-lg-12">
                  <div class="row align-self-center">
                    <div class="col-lg-3">
                      <b-form-group label="ID">
                        <b-form-input v-model="filterId" label="ID" placeholder="Enter your ID"></b-form-input>
                      </b-form-group>
                    </div>
<!--                    <div class="col-lg-5">-->
<!--                      <b-form-group id="input-group-1" label="CreateDate (วันเริ่มต้น - วันสุดท้าย)" label-for="input-1" class="mb-0">-->
<!--                        <date-range-picker-->
<!--                            class="w-100"-->
<!--                            :opens="'center'"-->
<!--                            @start-selection="logEvent('startSelection', $event)"-->
<!--                            @finish-selection="logEvent('finishSelection', $event)"-->
<!--                            :min-date="minDate"-->
<!--                            :max-date="maxDate"-->
<!--                            :singleDatePicker="false"-->
<!--                            :appendToBody="true"-->
<!--                            :ranges="false"-->
<!--                            :closeOnEsc="false"-->
<!--                            :autoApply="true"-->
<!--                            :locale-data="{ format: 'dd-mm-yyyy' }"-->
<!--                            v-model="filters">-->
<!--                        </date-range-picker>-->
<!--                      </b-form-group>-->
<!--                      <hr class="d-block d-md-none d-lg-none mb-0" />-->
<!--                    </div>-->
                    <div class="col-lg-3">
                      <b-form-group id="input-group-1" label="状态" label-for="input-1" class="mb-0">
                        <select class="form-control" v-model="filterStatus">
                          <option value="">
                            全部
                          </option>
                          <option :value="1">
                            未支付
                          </option>
                          <option :value="2">
                            已支付
                          </option>
                        </select>
                      </b-form-group>
                    </div>
                    <div class="col-lg-5">
                      <b-form-group id="input-group-1" label="UpdateDate (วันเริ่มต้น - วันสุดท้าย)" label-for="input-1" class="mb-0">
                        <date-range-picker
                            class="w-100"
                            :opens="'center'"
                            @start-selection="logEvent('startSelection', $event)"
                            @finish-selection="logEvent('finishSelection', $event)"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :singleDatePicker="false"
                            :appendToBody="true"
                            :ranges="false"
                            :closeOnEsc="false"
                            :autoApply="true"
                            :locale-data="{ format: 'dd-mm-yyyy' }"
                            v-model="filtersUpdateDate">
                        </date-range-picker>
                      </b-form-group>
                      <hr class="d-block d-md-none d-lg-none mb-0" />
                    </div>
                    <div class="col-lg-2 d-flex align-items-end">
                      <button class="btn btn-info btn-sm-res btn-block" v-on:click="getCashList()">
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="tablePrint" style="position: relative;">
              <b-table
                  show-empty empty-text="ไม่มีรายละเอียดข้อมูลยอดขาย" empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                  :items="order"
                  :fields="fields"
                  :filter="filter"
                  responsive :busy="busy"
                  class="scroll-bar-pop m-h-inherit table-min-500" outlined >
                <div slot="table-busy" class="text-center">
                  <BlockUI>
                    <div class="loader"></div>
                  </BlockUI>
                </div>
                <template slot="cashNum" slot-scope="row">{{ row.item.cashNum }}</template>
                <template slot="goodsCount" slot-scope="row">
                  {{ row.item.goodsCount }}
                </template>
                <template slot="agentIncome" slot-scope="row">
                  {{ row.item.agentIncome | numFormat('0,0.00') }}
                </template>
                <template slot="agentCost" slot-scope="row">
                  {{ row.item.agentCost | numFormat('0,0.00') }}
                </template>
                <template slot="address" slot-scope="row">
                  <span>{{(row.item.agentCost - row.item.agentIncome).toFixed(2)}}</span>
                </template>
                <template slot="payStatus" slot-scope="row">
                  <b-badge variant="primary" v-if="row.item.payStatus === 1">未支付</b-badge>
                  <b-badge variant="success" v-if="row.item.payStatus === 2">已支付</b-badge>
                </template>
                <template slot="manage" slot-scope="row">
                  <button
                      class="btn px-3 btn-sm btn-info"
                      @click="showDetail(row.item)"
                  >Detail</button>
                </template>
              </b-table>
              <div class="mt-3">
                <b-pagination
                    :total-rows="pagination.totalItem"
                    :current-page="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :value="pagination.currentPage"
                    @input="changePage"
                    align="right"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  收银任务订单列表  -->
    <b-modal centered no-close-on-backdrop no-close-on-esc v-model="modelCashDetailShow" @close="closeCashDetailModel"
             size="xl" hide-footer no-stacking>
      <template slot="modal-title">
        <div slot="header" class="bg-white border-0">
          <div class="row align-items-center">
            <div class="col-12">
              <h3 class="mb-0">Sales Records Detail</h3>
            </div>
          </div>
        </div>
      </template>
      <card shadow type="secondary" class="m--4">
        <b-table
            :items="members"
            :fields="fieldsDetail"
            :busy="busy"
            responsive="sm"
            style="min-height: 450px"
        >
          <div slot="table-busy" class="text-center">
            <BlockUI>
              <div class="loader"></div>
            </BlockUI>
          </div>
          <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>

          <template slot="index" slot-scope="data">
            <span class="text-sm">{{ data.index + 1 }}</span>
          </template>
          <!--        产品信息        -->
          <template slot="product" slot-scope="row">
            <span class="text-sm" v-if="row.item.orderType !== 5">包 裹 - {{row.item.detail.expressCode}}</span>
            <span class="text-sm" v-if="row.item.orderType === 5">商 品</span><br>
            <span class="text-sm" v-if="row.item.orderType === 5">{{row.item.detail.spuName}}-{{row.item.detail.salesCount}}</span>
            <span class="text-sm" v-if="row.item.orderType !== 5">
                    {{row.item.detail.pkgWeight}}kg
                    -
                    {{row.item.detail.pkgWidth}}cm
                    -
                    {{row.item.detail.pkgLenght}}cm
                    -
                    {{row.item.detail.pkgHeight}}cm
                  </span>
          </template>
          <!--        收件信息        -->
          <template slot="receiverInfo" slot-scope="row">
            <span class="text-sm" v-if="row.item.orderType !== 5">{{row.item.detail.receiverName}}</span><br>
            <span class="text-sm" v-if="row.item.orderType !== 5">{{row.item.detail.receiverPhone}}</span>
            <span v-if="row.item.orderType === 5">-</span>
          </template>
          <template slot="payStatus" slot-scope="row">
            <b-badge variant="success" style="font-size: 12px" pill v-if="row.item.detail.payStatus === 2">已支付</b-badge>
            <b-badge variant="primary" style="font-size: 12px" pill v-if="row.item.detail.payStatus === 1">待支付</b-badge><br>
          </template>
          <template slot="freight" slot-scope="row">
                  <span class="text-sm" v-if="row.item.orderType !== 5">
                    {{
                      (
                          row.item.detail.payFee -
                          row.item.detail.userCodServiceFee -
                          row.item.detail.userCodServiceTaxFee -
                          row.item.detail.userSppedServiceFee -
                          row.item.detail.userInsuranceServiceFee
                      ).toFixed(2)
                    }}

                  </span>
            <span v-if="row.item.orderType === 5">-</span>
          </template>
          <template slot="cod" slot-scope="row">
            <span class="text-sm" v-if="row.item.orderType !== 5">{{(row.item.detail.userCodServiceFee + row.item.detail.userCodServiceTaxFee).toFixed(2)}}</span>
            <span v-if="row.item.orderType === 5">-</span>
          </template>
          <template slot="speed" slot-scope="row">
            <span class="text-sm" v-if="row.item.orderType !== 5">{{row.item.detail.userSppedServiceFee}}</span>
            <span v-if="row.item.orderType === 5">-</span>
          </template>
          <template slot="Insurance" slot-scope="row">
            <span class="text-sm" v-if="row.item.orderType !== 5">{{row.item.detail.userInsuranceServiceFee}}</span>
            <span v-if="row.item.orderType === 5">-</span>
          </template>
          <template slot="total" slot-scope="row">
            <span class="text-sm" v-if="row.item.orderType !== 5">{{row.item.detail.payFee}}</span>
            <span v-if="row.item.orderType === 5">{{row.item.amount}}</span>
          </template>
          <template slot="manage" slot-scope="row">
<!--            <button-->
<!--                class="btn px-3 btn-sm btn-info"-->
<!--                v-if="row.item.detail.payStatus === 1 && row.item.orderType !== 5"-->
<!--                @click="showEditPackage(row.item)"-->
<!--            >แก้ไข</button>-->
<!--            <button-->
<!--                class="btn px-3 btn-sm btn-info"-->
<!--                v-if="row.item.detail.payStatus === 1 && row.item.orderType === 5"-->
<!--                @click="showEditCommodity(row.item,2)"-->
<!--            >แก้ไข</button>-->
<!--            <button-->
<!--                class="btn px-3 btn-sm btn-info"-->
<!--                v-if="row.item.detail.payStatus === 1 && row.item.orderType !== 5"-->
<!--                @click="fnDeleteExpressPkg(row.item)"-->
<!--            >删除</button>-->
<!--            <button-->
<!--                class="btn px-3 btn-sm btn-info"-->
<!--                v-if="row.item.detail.payStatus === 1 && row.item.orderType === 5"-->
<!--                @click="fnDeleteCommodity(row.item)"-->
<!--            >删除</button>-->
          </template>
        </b-table>
      </card>
    </b-modal>
  </div>
</template>
<script>
import ExportExcel from "@/components/custom/exportExcel/ExportExcel.vue";
import BtnLabel from "@/components/custom/printLabel/BtnLabel.vue";
import moment from "moment/moment";
import {cashlist, getPosDetailByCashNum} from "@/api/express";
import {dateLimitRanges} from "@/plugins/datePicker";
export default{
  components:{
    ExportExcel,
    BtnLabel
  },
  data(){
    return {
      minDate: null,
      maxDate: moment().format("YYYY-MM-DD"),
      filters: {
        startDate:"",
        endDate:""
      },
      filtersUpdateDate:{
        startDate:"",
        endDate:""
      },
      filterStatus: null,
      filterId:null,
      dataStatus:[
        { key: '1' , title: 'SUCCESS' },
        { key: '-3' , title: 'CANCEL' }
      ],
      filterUserCreate: null,
      dataUserCreate:[],
      totalNetPrice: 0,
      order: [],
      pagination: {
        totalPage: 1,
        totalItem: 0,
        currentPage: 1,
        perPage: 20,
      },
      fields:[
        { key: "cashNum", label: "ID"},
        { key: "goodsCount", label: "数量" },
        { key: "agentIncome", label: "收入" },
        { key: "agentCost", label: "成本" },
        { key: "address", label: "利润" },
        { key: "payStatus", label: "状态" },
        { key: "updateTime", label: "更新时间" },
        { key: "manage", label: "การจัดการ", sortable: false }
      ],
      fieldsDetail: [
        { key: "index", label: "#"},
        { key: "product", label: "产品信息"},
        { key: "receiverInfo", label: "收件信息" },
        { key: "payStatus", label: "支付状态" },
        { key: "freight", label: "运费" },
        { key: "cod", label: "COD" },
        { key: "speed", label: "SPEED" },
        { key: "Insurance", label: "Insurance" },
        { key: "total", label: "总价" },
        { key: "manage", label: "การจัดการ", sortable: false }
      ],
      filter: null,
      busy:false,
      modelCashDetailShow:false,
      members:[],
    }
  },
  created(){
    this.getCashList()
  },
  methods:{
    closeCashDetailModel(){
      this.modelCashDetailShow = false
    },
    showDetail(item){
      this.busy = true
      getPosDetailByCashNum({
        cashNum:item.cashNum,
        isError:false,
        isHaveShop:true
      })
          .then((res) => {
            this.members =res.data.detail
            this.cashInfo = res.data
            this.busy = false
            this.modelCashDetailShow = true
          })
    },
    logEvent( event , date ){
      const { minDate , maxDate } =  dateLimitRanges(event, date);
      this.minDate = minDate
      this.maxDate = maxDate
    },
    changePage(i){
      if (this.pagination.currentPage == i) return
      this.pagination.currentPage = i
      this.getCashList()
    },
  //   获取收银列表
    getCashList(){
      // let createStartDate = this.filters.startDate?moment(this.filters.startDate).format("YYYY-MM-DD 00:00:00"):''
      // let createEndDate = this.filters.endDate?moment(this.filters.endDate).format("YYYY-MM-DD 23:59:59"):''
      let updateStartTime = this.filtersUpdateDate.startDate?moment(this.filtersUpdateDate.startDate).format("YYYY-MM-DD 00:00:00"):''
      let updateEndTime = this.filtersUpdateDate.endDate?moment(this.filtersUpdateDate.endDate).format("YYYY-MM-DD 23:59:59"):''
      let params = {
        // createEndDate: createStartDate?createStartDate:'',
        // createStartDate: createEndDate,
        cashNum: this.filterId,
        pageIndex: this.pagination.currentPage,
        pageSize: this.pagination.perPage,
        updateEndTime: updateEndTime,
        updateStartTime:updateStartTime,
        payStatus: this.filterStatus
      }
      cashlist(params)
          .then((res) => {
            console.log(res)
            this.order = res.data.records
            this.pagination.totalPage = res.data.total
            this.pagination.totalItem = res.data.size
            this.pagination.perPage = res.data.size
            this.pagination.currentPage = res.data.pages
          })
    }

  }
}
</script>
